import Header from '../../Components/Header'
import GlobalMap from '../../Components/globalMap'

function GlobalLocations() {
    return (
        <div>
            <Header />
            <GlobalMap className='map'/>
        </div>
    )
}

export default GlobalLocations